import React, { useEffect, useState } from "react";
import "./FlipCard.css";
import TypewriterText from "components/shared/TypeWriterText";

import evenementFront from "assets/puzzles/ortivis/évènement_recto.svg";

const OrtivisActionCard = ({ card, onValidate }) => {
	return (
		<div className="card-container flex flex-col  mt-8">
			<div className={`card `}>
				{/* Question Side */}
				<div className="card-face front shadow-[12px_12px_0px_rgba(0,0,0,0.3)]">
					<div className="relative h-full w-full">
						<img
							src={evenementFront}
							alt="Question Background"
							className="absolute h-full w-full object-cover"
						/>
						<div className="absolute top-[28px]  p-6 px-12 w-full flex flex-col items-center">
							<h3 className="mb-4 px-2 text-center text-sm font-bold text-gray-700">
								<TypewriterText text={card.text} />
							</h3>
						</div>
					</div>
					<button
						onClick={() => {
							onValidate(card);
						}}
						className={`absolute bottom-4 right-2 rounded-full px-4 py-2 border-black text-black font-bold `}
					>
						{"VALIDER"}
					</button>
				</div>
			</div>
		</div>
	);
};

export default OrtivisActionCard;
